import { takeLatest, call, put, takeEvery } from 'redux-saga/effects';
import _ from 'lodash';

import {
  FETCH_JOB_PROFILES,
  fetchJobProfilesSuccess,
  fetchJobProfilesFailed,
  fetchingJobProfiles,
  FETCH_JOB_PROFILE,
  fetchJobProfileSuccess,
  fetchJobProfileFailed,
  fetchingJobProfile,
} from '../actions/jobprofiles';
import {
  saveJobProfileRoutine,
  removeJobProfileRoutine,
} from '../routines';

import { fetchDoc, fetchCol, getTenantPath, setSaga } from './helper';
import { toArray } from '../utils/helper';

function fetchJobProfiles() {
  return fetchCol(getTenantPath('/jobprofiles'))
    .then((profiles) => toArray(profiles).filter(p => !p.deleted));
}

function* fetchJobProfilesSaga() {
  try {
    yield put(fetchingJobProfiles());
    const jobProfiles = yield call(fetchJobProfiles);
    yield put(fetchJobProfilesSuccess(jobProfiles));
  } catch (e) {
    yield put(fetchJobProfilesFailed(e));
  }
}

function* watchFetchJobProfilesSaga() {
  yield takeLatest(FETCH_JOB_PROFILES, fetchJobProfilesSaga);
}

function fetchJobProfile(id) {
  const path = getTenantPath(`/jobprofiles/${id}`);
  return fetchDoc(path);
}

function* fetchJobProfileSaga(action) {
  try {
    yield put(fetchingJobProfile());
    const jobProfile = yield call(fetchJobProfile, action.jobProfileId);
    yield put(fetchJobProfileSuccess(jobProfile));
  } catch (e) {
    console.error('Failed to load job profile', e);
    yield put(fetchJobProfileFailed(e));
  }
}

function* watchFetchJobProfileSaga() {
  yield takeLatest(FETCH_JOB_PROFILE, fetchJobProfileSaga);
}

function* watchSaveJobProfileSaga() {
  yield takeEvery(saveJobProfileRoutine.TRIGGER, setSaga(saveJobProfileRoutine,
    (payload) => {
      console.log('payload.values', payload.values);
      return getTenantPath(`jobprofiles/${payload.values.get('id')}`);
    },
    (payload) => _.pick(payload.values.toJS(), ['name', 'icon', 'description', 'stages', 'relativeTo'])
  ));
}

function* watchRemoveJobProfileSaga() {
  yield takeEvery(removeJobProfileRoutine.TRIGGER, setSaga(removeJobProfileRoutine,
    (jobProfile) => getTenantPath(`jobprofiles/${jobProfile.id}`),
    () => ({
      deleted: { at: new Date().toISOString() },
    })));
}

export {
  fetchJobProfilesSaga,
  watchFetchJobProfilesSaga,
  fetchJobProfileSaga,
  watchFetchJobProfileSaga,
  watchSaveJobProfileSaga,
  watchRemoveJobProfileSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/jobprofiles.js